import { URLS } from "@constants/urls";
import api from "@helpers/api";
import { UpdateEmail } from "@type/HRM/settings/updateEmail";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEE}`;

export const updateEmail = async (employeeId: number, data: UpdateEmail) => {
  const response = await api.post(
    `${apiEndPoint}/${employeeId}/${URLS.UPDATE_USER_NAME}`,
    data,
  );
  return response.data;
};
